import { render, staticRenderFns } from "./ContentsTab.vue?vue&type=template&id=1e5641ec&"
import script from "./ContentsTab.vue?vue&type=script&lang=js&"
export * from "./ContentsTab.vue?vue&type=script&lang=js&"
import style0 from "./ContentsTab.vue?vue&type=style&index=0&id=1e5641ec&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports